import { useWorkspacesStore } from '@common/modules/workspaces/stores/workspaces.store'
import type { Workspace } from '@common/modules/workspaces/types'

export function loadWorkspaceFromStore(): Workspace | null {
  return useWorkspacesStore.getState().currentWorkspace ?? useWorkspacesStore.getState().workspaces[0] ?? null
}
